export default {
    methods: {
        calcAlign(textAlign, fallback) {
            if (!textAlign) return fallback
            return textAlign
        }
    }
}
